import { LocalStorageType } from "../types/localStorage.type";

export function clearSessionData(): void {
    localStorage.removeItem(LocalStorageType.Menu);
    localStorage.removeItem(LocalStorageType.JwtToken);
    localStorage.removeItem(LocalStorageType.Branches);
    localStorage.removeItem(LocalStorageType.Tenant);
    localStorage.removeItem(LocalStorageType.UserDocument);
}